<template>
  <v-form ref='form' lazy-validation class="main-block__content__send-form block-shadow">
    <v-text-field
        single-line
        required
        autocomplete="off"
        :rules="modelsRules.nameRules"
        placeholder="Імʼя"
        v-model="models.name">
    </v-text-field>
    <v-text-field
        single-line
        required
        autocomplete="off"
        :rules="modelsRules.phoneRules"
        v-mask="'+38(0##)###-##-##'"
        placeholder="+38(0__)___-__-__" v-model="models.phone">
    </v-text-field>

    <v-btn
        small
        @click="order(models, gaFormTag)"
        class="primary d-flex flex-fill"
        elevation="2">
      Забронювати консультацію
    </v-btn>
  </v-form>
</template>

<script>
import Orders from "../services/orders";
import {phoneValidation} from "../validators/validators";

export default {
  name: "OrderForm",
  props: ['landingCodename', 'gaFormTag'],
  data() {
    return {
      models: {
        name: '',
        phone: '',
      },
      modelsRules: {
        nameRules: [
          v => !!v || 'Обовʼязкове поле',
        ],
        phoneRules: [
          v => !!v || 'Обовʼязкове поле',
          v => (v && !!phoneValidation(v)) || 'Невірний формат телефону'
        ],
      }
    }
  },
  methods: {
    order(formData, gaTag) {
      const self = this
      if (this.$refs.form.validate()) {
        formData.landing_codename = this.$props.landingCodename
        Orders.createOrder(formData).then(function (response) {
          self.$basicDialog.open({text: 'Очікуйте дзвінка оператора'})
          self.$refs.form.reset()
          // send to GoogleAnalytics
          if (gaTag) {
            self.$ga.event('form', gaTag)
          }
        }).catch(function (error) {
          console.log(error)
        });
      }
    }
  },
}
</script>

<style scoped>
.main-block__content__send-form {
  padding: 25px 35px;
  background-color: rgba(243, 243, 243, 0.99);
  border-radius: 25px;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.main-block__content__send-form .v-input {
  margin-right: 15px;
}

.main-block__content__send-form input, button {
  font-size: 14px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

@media (max-width: 800px) {
  .main-block__content__send-form {
    padding: 25px;
  }

  .main-block__content__send-form .v-btn {
    margin-top: 15px;
  }
}

@media (max-width: 600px) {
  .main-block__content__send-form .v-input {
    margin-right: 0;
  }
}
</style>